import { render, staticRenderFns } from "./BoFoodMeter.vue?vue&type=template&id=37387094&"
import script from "./BoFoodMeter.vue?vue&type=script&lang=js&"
export * from "./BoFoodMeter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports